import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/material';
import { Colors } from 'library';

export function Search({ handleChange }: { handleChange: (value: string | boolean, formKey: string) => void }) {
    return (
        <SearchBarContainer>
            <StyledSearchIcon />
            <SearchBar
                placeholder="Search by name..."
                type="search"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleChange(event.target.value, 'searchQuery')
                }
            />
        </SearchBarContainer>
    );
}

const SearchBarContainer = styled('div')({
    alignItems: 'center',
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 12,
    display: 'flex',
    height: 48,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:focus-within': {
        borderColor: Colors.darkNavy,
        boxShadow: `0 0 0 2px rgba(0,47,77,0.08)`,
    },
});

const StyledSearchIcon = styled(SearchIcon)({
    color: Colors.mediumNavy,
    marginLeft: 14,
    fontSize: 22,
});

const SearchBar = styled('input')({
    color: Colors.darkNavy,
    width: '100%',
    border: 'none',
    borderRadius: 12,
    padding: '12px 14px 12px 10px',
    outline: 'none',
    fontSize: 15,
    fontFamily: 'Outfit',
    backgroundColor: 'transparent',
    '&::placeholder': {
        color: Colors.mediumGrey,
    },
});
